import React from 'react'
import { GridApi } from 'ag-grid-community'
import { ToggleButton } from 'view/components/buttons'
import { deltaColumnIds } from './LiveGridColumnNames'
import { GridToolbarSettings } from 'store/grid'
import * as gridIcons from 'view/components/datagrid/styles/gridIconSet'
import { Translation } from 'locale'

export interface DeltaToolbarButtonProps {
  gridApi: GridApi | null
  toolbarSettings: GridToolbarSettings
  onToolbarSettingsChanged: (toolbarSettings: GridToolbarSettings) => unknown
}

export class DeltaToolbarButton extends React.Component<DeltaToolbarButtonProps> {
  render() {
    return (
      <ToggleButton
        dataTestId={'DeltaToolbarButton-ToggleButton'}
        tooltip={Translation.SC_SHOW_DELTAS}
        onToggle={this.onToggleDelta}
        on={this.props.toolbarSettings.showDelta}>
        {gridIcons.deltaIcon}
      </ToggleButton>
    )
  }

  private onToggleDelta = () => {
    const { toolbarSettings, onToolbarSettingsChanged } = this.props

    this.toggleDeltaColumnsVisibility()

    const updatedToolbarSettings: GridToolbarSettings = {
      ...toolbarSettings,
      showDelta: !toolbarSettings.showDelta
    }
    onToolbarSettingsChanged(updatedToolbarSettings)
  }

  private toggleDeltaColumnsVisibility() {
    const { gridApi, toolbarSettings } = this.props
    if (gridApi) {
      gridApi
        .getColumns()
        ?.filter(column => deltaColumnIds.some(deltaColumnId => column.getColId().startsWith(deltaColumnId)))
        .forEach(deltaColumn => {
          const parentVisible = gridApi.getColumn(deltaColumn.getColDef().headerComponentParams.parent)?.isVisible()
          if (parentVisible && !toolbarSettings.showDelta) {
            gridApi.setColumnsVisible([deltaColumn], true)
          } else {
            if (deltaColumn.isVisible()) {
              gridApi.setColumnsVisible([deltaColumn], false)
            }
          }
        })
    }
  }
}
